import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'staff'
const initialState = {
  count: null,
  list: null,
}

export const search = createApiAction('school/search', client.search('/api/setting/school'))
export const get = createApiAction('school/get', client.retrieve(`/api/setting/school/:id`))
export const save = createApiAction('school/save', client.save('/api/setting/school'))
export const destroy = createApiAction('school/delete', client.destroy('/api/setting/school/:id'))

const updateList = (state, action) => {
  const found = state.list.find(item => item.id === action.payload.id)
  state.list = found
    ? state.list.map(item => (found.id === item.id ? action.payload : item))
    : [action.payload, ...state.list]
}

const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(search.fulfilled, (state, action) => {
        state.list = action.payload.rows
        state.count = action.payload.count
      })
      .addCase(get.fulfilled, updateList)
      .addCase(save.fulfilled, updateList)
      .addCase(destroy.fulfilled, (state, action) => {
        state.list = state.list.filter(item => item.id !== action.payload.id)
      })
  },
})

export default sessionSlice.reducer
